import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    userdata : {},
    savedlayouts: [],
    customerdata: {},
    cartdata: [],
    inkcustomerdata: {}
  }

  export const userReducer = createReducer(initialState, (builder) => {
    builder.addMatcher(
      (action) => {
        return action.type === "userdata";
      },
      (state, action) => {
        state.userdata = action.payload;
      }
    );
    builder.addMatcher(
      (action) => {
        return action.type === "customerdata";
      },
      (state, action) => {
        state.customerdata = action.payload;
      }
    );
    builder.addMatcher(
      (action) => {
        return action.type === "inkcustomerdata";
      },
      (state, action) => {
        state.inkcustomerdata = action.payload;
      }
    );
    builder.addMatcher(
      (action) => {
        return action.type === "cartdata";
      },
      (state, action) => {
        state.cartdata = action.payload;
      }
    );
    builder.addMatcher(
      (action) => {
        return action.type === "savedlayouts";
      },
      (state, action) => {
        state.savedlayouts = action.payload;
      }
    );
  });